export default __webpack_public_path__ + "static/media/lv.c0f67457.svg";